import "./_timeline.scss";

document.addEventListener("DOMContentLoaded", () => {
  // Recupera il blocco timeline se non presente esce
  const block = document.querySelector(".block_timeline");
  if (!block) return;

  const timeline = block.querySelector("ol");
  const arrowPrev = block.querySelector(".arrow__prev");
  const arrowNext = block.querySelector(".arrow__next");
  const scrollStep = 370; // px da muovere ogni clic
  let currentTranslate = 0;

  // Calcola quanto può scorrere al massimo la timeline
  const getMaxScroll = () =>
    Math.max(0, timeline.scrollWidth - timeline.clientWidth + 32);

  // Determina se le frecce devono essere attive o disattivate
  const updateButtons = () => {
    const maxScroll = getMaxScroll();

    const prevDisabled = currentTranslate >= 0 || maxScroll === 0;
    const nextDisabled =
      Math.abs(currentTranslate) >= maxScroll || maxScroll === 0;

    // Classe visiva
    arrowPrev.classList.toggle("disabled", prevDisabled);
    arrowNext.classList.toggle("disabled", nextDisabled);

    // Proprietà/attributo reale (blocca i click se true)
    arrowPrev.disabled = prevDisabled;
    arrowNext.disabled = nextDisabled;

    // Accessibilità
    arrowPrev.setAttribute("aria-disabled", prevDisabled ? "true" : "false");
    arrowNext.setAttribute("aria-disabled", nextDisabled ? "true" : "false");
  };
  //traslazione orizzontale alla timeline
  const applyTranslate = (value) => {
    timeline.style.transform = `translate3d(${value}px, 0, 0)`;
  };
  //Funzione che gestisce lo scroll al clic delle frecce
  const scrollTimeline = (direction) => {
    const maxScroll = getMaxScroll();
    currentTranslate += direction * scrollStep;
    currentTranslate = Math.max(Math.min(0, currentTranslate), -maxScroll);
    applyTranslate(currentTranslate);
    updateButtons();
  };
  //Collega la funzione scrollTimeline alle frecce
  arrowPrev.addEventListener("click", () => scrollTimeline(1));
  arrowNext.addEventListener("click", () => scrollTimeline(-1));

  // Drag (pointer events for mouse + touch)
  let isDown = false;
  let startX = 0;
  let startTranslate = 0;
  timeline.style.touchAction = "pan-y"; // evita il comportamento predefinito del touch su mobile

  timeline.addEventListener("pointerdown", (e) => {
    isDown = true;
    timeline.setPointerCapture(e.pointerId);
    startX = e.clientX;
    startTranslate = currentTranslate;
    // disabilita temporaneamente la transition per drag fluido
    timeline.style.transition = "none";
  });

  timeline.addEventListener("pointermove", (e) => {
    if (!isDown) return;
    const dx = e.clientX - startX;
    const maxScroll = getMaxScroll();
    currentTranslate = startTranslate + dx;
    currentTranslate = Math.max(Math.min(0, currentTranslate), -maxScroll);
    applyTranslate(currentTranslate);
    updateButtons();
  });

  const endDrag = (e) => {
    if (!isDown) return;
    isDown = false;
    try {
      timeline.releasePointerCapture(e.pointerId);
    } catch (err) {
      // alcuni browser potrebbero non permettere release se pointerId non valido
    }
    // ripristina transition
    timeline.style.transition = "";
  };

  timeline.addEventListener("pointerup", endDrag);
  timeline.addEventListener("pointercancel", endDrag);
  window.addEventListener("blur", () => (isDown = false)); // sicurezza

  // Tastiera
  document.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft") scrollTimeline(1);
    if (e.key === "ArrowRight") scrollTimeline(-1);
  });

  // Ricalcola limiti al resize e corregge posizione se necessario
  window.addEventListener("resize", () => {
    const max = getMaxScroll();
    currentTranslate = Math.max(Math.min(0, currentTranslate), -max);
    applyTranslate(currentTranslate);
    updateButtons();
  });

  // inizializza stato
  applyTranslate(currentTranslate);
  updateButtons();
});
